export interface Size {
    width: number;
    height: number;
}

export const INIT_SIZE: Size = {
    width: 0,
    height: 0,
};
